function imageUrlFromSignedBlobId(signedBlobId) {
  const baseUrl = window.ENV.CDN_DOMAIN || window.ENV.APP_URL || ''
  return `${baseUrl}/rails/active_storage/blobs/${signedBlobId}/image.png?client_id=${window.ENV.CLIENT_ID}`
}

export default imageUrlFromSignedBlobId
